import { render, staticRenderFns } from "./payment-panel-select-period.vue?vue&type=template&id=f38b545c&scoped=true"
import script from "./payment-panel-select-period.vue?vue&type=script&lang=js"
export * from "./payment-panel-select-period.vue?vue&type=script&lang=js"
import style0 from "./payment-panel-select-period.vue?vue&type=style&index=0&id=f38b545c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38b545c",
  null
  
)

export default component.exports